/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import moment from 'moment';
import { DateInputRow } from '../../../../../javascript/shared/components/form';
import { FormInputGroup } from '../../react/form_input_group.jsx';
import { FormRow } from '../../react/form_row.jsx';

export class ConferenceFormComponent extends React.Component {
        static initClass() {
          this.propTypes = {
            startDate: PropTypes.string,
            endDate: PropTypes.string,
            eventInstances: PropTypes.array,
            invalidText: PropTypes.string
          };
        
          this.defaultProps = {
            startDate: null,
            endDate: null,
            eventInstances: [],
            invalidText: "Dates invalid"
          };
        }

        constructor(props) {
          super(props);
          this._inputChanged = this._inputChanged.bind(this);
          this._validateState = this._validateState.bind(this);
          this._updateScheduleDate = this._updateScheduleDate.bind(this);
          this._updateSummaryText = this._updateSummaryText.bind(this);
          this._renderScheduledDates = this._renderScheduledDates.bind(this);
this.render = this.render.bind(this);
        
          this.state = {
            start_date: props.startDate,
            start_date_invalid: true,
            end_date: props.endDate,
            end_date_invalid: true,
            valid_entry: false,
            scheduled_date: props.eventInstances
          };
        }

        _inputChanged(event, value) {
        
          switch (event.target.name) {
            case 'start_date':
              if ((value === 'error') || (value === 'blank')) {
                return this.setState({start_date_invalid: true, start_date: null}, this._validateState);
              } 
                return this.setState({start_date_invalid: false, start_date: value}, this._validateState);
              
            case 'end_date':
              if ((value === 'error') || (value === 'blank')) {
                return this.setState({end_date_invalid: true, end_date: null}, this._validateState);
              } 
                return this.setState({end_date_invalid: false, end_date: value}, this._validateState);
              
          }
        }
      
        // Validate the state and set the global validation flag appropriately
        _validateState() {
          // Form validation checks
          const valid_start_date = !this.state.start_date_invalid && this.state.start_date;
          const valid_end_date = !this.state.end_date_invalid || this.state.end_date;
          const start_date_invalid = this.state.start_date_invalid || !this.state.start_date;
          const end_date_invalid = this.state.end_date_invalid || !this.state.end_date;
        
          return this.setState({
              valid_entry: valid_start_date && valid_end_date,
              start_date_invalid,
              end_date_invalid
            },
           this._updateScheduleDate);
        }

        _updateScheduleDate() {
          this.setState({summary_text: this._updateSummaryText(this.state.start_date, this.state.end_date)});

          if (this.state.start_date && this.state.end_date) {
            const format = "YYYY-MM-DD";
            const dates = [];
            const start_date = moment(this.state.start_date);
            const now = start_date.clone();
            const end_date = moment(this.state.end_date);
          
            if (end_date.diff(start_date, 'days') >= 0) {
              while (now.isSameOrBefore(end_date)) {
                dates.push(`${now.format(format)  },,`);
                now.add(1, "days");
              }
            
              return this.setState({
                scheduled_date: dates,
                summary_text: this._updateSummaryText(this.state.start_date, this.state.end_date)
              });
            } 
              return this.setState({
                schedule_date: [],
                summary_text: this._updateSummaryText(this.state.start_date, this.state.end_date)
              });
            
          }
        }
      
        _updateSummaryText(start_date, end_date){
          if (!start_date || !end_date) { return this.props.invalidText; }
          return `${moment(start_date).format('ddd, MMM D, YYYY')} through ${moment(end_date).format('ddd, MMM D, YYYY')}`;
        }

        _renderScheduledDates() {
          if (this.state.scheduled_date) {
            return _.map(this.state.scheduled_date, instance_date => {
              return <input key={instance_date} type='hidden' name='scheduled_date[]' value={instance_date} />;
            });
          }
        }

        render() {
          return <div>
            {this._renderScheduledDates()}
          
            <input type="hidden" name="event[start_date]" value={this.state.start_date} />
          
            <DateInputRow label="Start Date"
                          name="start_date"
                          placeholder="'Tomorrow' or 'Next Friday' or '4/10'"
                          initialValue={this.state.start_date}
                          onChange={this._inputChanged}
                          showPreview={false}
                          showError={false}
                          required={true} />
          
            <DateInputRow label="End Date"
                          name="end_date"
                          placeholder="'Tomorrow' or 'Next Friday' or '4/10'"
                          initialValue={this.state.end_date}
                          onChange={this._inputChanged}
                          showPreview={false}
                          showError={false}
                          required={true} />
                        
            {this.state.summary_text && <FormRow title="Summary">
              <div className="schedule-summary">{this.state.summary_text}</div>
            </FormRow>}
          </div>;
        }
      }
ConferenceFormComponent.initClass();